// extracted by mini-css-extract-plugin
module.exports = {"xs":"0rem","sm":"30rem","md":"48rem","lg":"64rem","xl":"75rem"};